// app/utils/format.ts

// ✅ Formatar moeda (Real Brasileiro)
export const formatCurrency = (value: number | string) => {
  const number = typeof value === 'string' ? parseFloat(value) : value;
  return number.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  });
};

// ✅ Formatar datas (simples)
export const formatDate = (date: string | Date) => {
  const d = new Date(date);
  return d.toLocaleDateString('pt-BR');
};

// ✅ Formatar datas completas
export const formatFullDate = (date: string | Date) => {
  const d = new Date(date);
  return d.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
};

// ✅ Exibir texto do status de forma amigável
export const formatStatus = (status: string) => {
  const map: Record<string, string> = {
    pending: 'Pendente',
    confirmed: 'Confirmada',
    pending_dispute: 'Em disputa',
    completed: 'Concluída',
    cancelled: 'Cancelada',
  };

  return map[status.toLowerCase()] || status;
};
